import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class LevelTranslatorAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVccMin = 1.5;
		this.normVccMax = 5;
		this.normTpdMax = 3;
		this.normIoMax = 10;

		this.rankVccMin = 0;
		this.rankVccMax = 0;
		this.rankTpdMax = 0;
		this.rankIoMax = 0;

		this.weightVccMin = 0.1;
		this.weightVccMax = 0.1;
		this.weightTpdMax = 0.2;
		this.weightIoMax = 0.1;

		this.rVccMin = 0;
		this.rVccMax = 0;
		this.rTpdMax = 0;
		this.rIoMax = 0;
	}

	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_VccMin,rVccMin,rankVccMin,' +
					'part_VccMax,rVccMax,rankVccMax,' +
					'part_TpdMax,rTpdMax,rankTpdMax,' +
					'part_IoMax,rIoMax,rankIoMax,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Supply voltage  VCC Min (V)---------------------------------------------
		[this.rankVccMin, this.rVccMin] = this.calculateRankSingleSliderLTE(CIDS.V_CC_MIN, product, this.normVccMin);

		// ---------------------------------------------Supply voltage  VCC Max (V)---------------------------------------------
		[this.rankVccMax, this.rVccMax] = this.calculateRankSingleSliderGTE(CIDS.V_CC_MAX, product, this.normVccMax);

		// ---------------------------------------------Propagation delay  tpd Max (ns)---------------------------------------------
		[this.rankTpdMax, this.rTpdMax] = this.calculateRankSingleSliderLTE(CIDS.T_PD_MAX, product, this.normTpdMax);

		// ---------------------------------------------Output Current  IO Max (mA)---------------------------------------------
		[this.rankIoMax, this.rIoMax] = this.calculateRankSingleSliderGTE(CIDS.I_O_MAX, product, this.normIoMax);

		// -------------------------------------------------------------------------------------------

		let feRank =
			this.weightVccMin * this.rankVccMin +
			this.weightVccMax * this.rankVccMax +
			this.weightTpdMax * this.rankTpdMax +
			this.weightIoMax * this.rankIoMax;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank =
			(1 - this.weightVccMin - this.weightVccMax - this.weightTpdMax - this.weightIoMax) * super.execute(product) +
			feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
